import * as S from './style';
import FormLogin from '../../components/FormLogin';

export default function Login() {
    return (
        <S.Container>
            <S.ContentImage>
                <S.Image src="/ImgLoginSide.svg" alt="Imagem do Login" loading="lazy" />
            </S.ContentImage>
            <S.ContentForm>
                <FormLogin />
            </S.ContentForm>
        </S.Container>
    )
}